import { Stack, Typography } from '@mui/joy';
import { TrashSimple } from '@phosphor-icons/react';

import { useAgGridTableContext } from 'core/states';
import { RemovePricingProfileAdminUserButton } from 'pricing/components';
import { IPricingProfileAdminUser } from 'pricing/types';
import { Color, Direction, Level } from 'theme/enums';

interface IProps {
  data: IPricingProfileAdminUser;
  isEditable?: boolean;
}

export const ActionsCell = ({ data, isEditable = true }: IProps) => {
  const { gridApi } = useAgGridTableContext();

  const refreshTable = () => {
    gridApi?.refreshServerSide();
  };

  if (data.isOwner) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <RemovePricingProfileAdminUserButton
        pricingProfileAdminUsers={[data]}
        buttonElement={
          <Typography
            color={isEditable ? Color.DANGER : Color.NEUTRAL}
            level={Level.BODY_SM}
            sx={{ cursor: isEditable ? 'pointer' : 'not-allowed', opacity: isEditable ? 1 : 0.5 }}
          >
            <TrashSimple />
          </Typography>
        }
        onRemoveSuccess={refreshTable}
        disabled={!isEditable}
      />
    </Stack>
  );
};
